module.exports = __webpack_public_path__ + "media/images/icons/illustration/link-abc44ed09e43c86c655901e770fa3460.svg";